export default __webpack_public_path__ + "static/media/330_business04-jp-mobile.98530609.png";